// extracted by mini-css-extract-plugin
var _1 = "src-themes__dark--psZhV7oUWlZFtQIVxP70";
var _2 = "src-themes__light--Ai8WupiLppL1wjjjmUGw";
export { _1 as "dark", _2 as "light" }
